import { GridService, IGridService } from '../shared/grid/grid.service';

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SampleSurveyType } from '../models/sampleSurveyType.model';
import { Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';
import { Lookup } from '../models/lookup.model';

@Injectable({
  providedIn: 'root'
})
export class SampleSurveyTypeService extends GridService<SampleSurveyType> {

    private cache$: Observable<Lookup[]> | null = null;

    constructor(http: HttpClient) {
        super('SampleSurveyType', http);
    }

    getAll(filterBy: string = ''): Observable<Lookup[]> {
        if (filterBy) {
            const params = new HttpParams().set('filterBy', filterBy);
            return this.http.get<Lookup[]>(this.getApiUrl(`${this.controllerName}/GetAll`), { params });
        }
        if (!this.cache$) {
            this.cache$ = this.http.get<Lookup[]>(this.getApiUrl(`${this.controllerName}/GetAll`)).pipe(
                shareReplay({ bufferSize: 1, refCount: true })
            );
        }
        return this.cache$;
    }

    clearCache(): void {
        this.cache$ = null;
    }

    override create(payload: SampleSurveyType) {
        return super.create(payload).pipe(tap(() => this.clearCache()));
    }

    override update(payload: SampleSurveyType) {
        return super.update(payload).pipe(tap(() => this.clearCache()));
    }

    override delete(id: string) {
        return super.delete(id).pipe(tap(() => this.clearCache()));
    }

    override patch(id: string, payload: Partial<SampleSurveyType>) {
        return super.patch(id, payload).pipe(tap(() => this.clearCache()));
    }

    createRange(payload: SampleSurveyType[]): Observable<SampleSurveyType[]> {
        return this.http.post<SampleSurveyType[]>(
            this.getApiUrl(`${this.controllerName}/CreateRange`),
            payload
        ).pipe(tap(() => this.clearCache()));
    }
}
